import { createBrowserRouter } from "react-router-dom";
import Home from "../views/home/home";
import Profile from "../views/profile/profile";
import AboutUs from "../views/about/about_us";
import News from "../views/news";
import ParishListing from "../views/parish_listing/parish_listing";
import CommitteeListing from "../views/committee_listing/committee_listing";
import ContactUs from "../views/contact_us/contact_us";
import Login from "../views/admin_portal/login";
import Dashboard from "../views/admin_portal/dashboard/dashboard";
import Users from "../views/admin_portal/users/users";
import CreateAdmin from "../views/admin_portal/users/create_admin/create_admin";
import UploadNews from "../views/admin_portal/upload_news/upload_news";
import AdminNews from "../views/admin_portal/news/news";
import EditNewsPage from "../views/admin_portal/news/edit_news_page";
import DycYuvaDabazoPage from "../views/DYC";
import PitchBattleRegistrationPage from "../views/DYC/pitch_battle";
import DycRegistrationListPage from "../views/DYC_registration_list";
import DycAdminPage from "../views/admin_portal/dyc";
import YuvaGaaz from "../views/yuva_gaaz/yuva_gaaz";
import EventCalender from "../views/event_calender/event_calendar";
import NewsList from "../views/news/news_list";
import ProAndYoucatTraining from "../views/pro_and_youcat_training/pro_and_youcat_training";
import SurveyResponse from "../views/survey/survey_response/survey_response";
import Surveys from "../views/survey/survey";
import AdminSurveys from "../views/admin_portal/survey/survey";
import CreateSurvey from "../views/admin_portal/survey/create_survey/create_survey";
import RegistrationList from "../views/pro_and_youcat_training/registration_list";
import SurveyRespodents from "../views/admin_portal/survey/surveyRespodents/surveyRespodents";
import PrivateRoute from "./private_route";
import NotFound from "../views/not_found/not_found";
import Details from "../views/admin_portal/survey/surveyRespodents/details";
import Vanamahostava from "../views/vanamahostava/vanamahostava";
import PromptAndPaint from "../views/dabazo_2.O/prompt_n_paint/prompt_and_paint";
import Redon from "../views/admin_portal/redon/redon";
import Donors from "../views/donors/donors";
import GalleryPage from "../views/gallery";
import AdminGallery from "../views/admin_portal/gallery/gallery";
import RedonPage from "../views/redon";
import YoucatPage from "../views/youcat";
import DeaneryYouthCommissionPage from "../views/deanery_youth_commission";
import DeaneryMembersAdminPage from "../views/admin_portal/deanery_members/deanery_members";
import AdminYuvagaazPage from "../views/admin_portal/yuvagaaz/yuvagaaz";
import AboutAdminPage from "../views/admin_portal/about/about";
import DexcoAdminPage from "../views/admin_portal/dexco/dexco";
import DexcoPage from "../views/dexco";
import YoucatAdminPage from "../views/admin_portal/youcat/youcat";
import YoucatMonthlyUpdateFormPage from "../views/youcat/monthly_update_form";
import ForgotPassword from "../views/admin_portal/login/forgot_password";
import YoucatQuizAuthPage from "../views/youcat/quiz";
import YoucatQuizPortalPage from "../views/youcat/quiz/portal";

export const routes = [
  {
    path: "/",
    element: <Home />,
    title: "Home",
  },
  {
    path: "/profile",
    element: <Profile />,
    title: "Profile",
  },
  {
    path: "/about",
    element: <AboutUs />,
    title: "About",
  },
  {
    path: "/dexco",
    element: <DexcoPage />,
    title: "DEXCO",
  },
  {
    path: "/news/:id",
    element: <News />,
    title: "News",
  },
  {
    path: "/news-view/:id",
    element: <News />,
    title: "News",
  },
  {
    path: "/parishes",
    element: <ParishListing />,
    title: "Parishes",
  },
  {
    path: "/parishes/parish",
    element: <CommitteeListing />,
    title: "Parish",
  },
  {
    path: "/contactus",
    element: <ContactUs />,
    title: "Contact Us",
  },
  {
    path: "/donors",
    element: <Donors />,
    title: "Donors",
  },
  {
    path: "/gallery",
    element: <GalleryPage />,
    title: "Gallery",
  },
  {
    path: "/redon",
    element: <RedonPage />,
    title: "REDON",
  },
  {
    path: "/youcat",
    element: <YoucatPage />,
    title: "YouCat",
  },
  {
    path: "/youcat/monthly-update",
    element: <YoucatMonthlyUpdateFormPage />,
    title: "YouCat Monthly Update",
  },
  {
    path: "/youcat/quiz",
    element: <YoucatQuizAuthPage />,
    title: "YouCat Quiz",
  },
  {
    path: "/youcat/quiz/portal",
    element: <YoucatQuizPortalPage />,
    title: "YouCat Quiz Portal",
  },
  {
    path: "/deanery-youth-commission",
    element: <DeaneryYouthCommissionPage />,
    title: "Deanery Youth Commission",
  },
  {
    path: "/admin/login",
    element: <Login />,
    title: "Login",
  },
  {
    path: "/forgotPassword",
    element: <ForgotPassword />,
    title: "Forgot Password",
  },
  {
    path: "/admin/home",
    element: <PrivateRoute element={<Dashboard />} module="dashboard" />,
    title: "Home",
  },
  {
    path: "/admin/users",
    element: <PrivateRoute element={<Users />} module="users" />,
    title: "Users",
  },
  {
    path: "/admin/users/createAdmin",
    element: <PrivateRoute element={<CreateAdmin />} module="users" />,
    title: "Create Admin",
  },
  {
    path: "/admin/uploadNews",
    element: <PrivateRoute element={<UploadNews />} module="news" />,
    title: "Upload News",
  },
  {
    path: "/admin/news",
    element: <PrivateRoute element={<AdminNews />} module="news" />,
    title: "News",
  },
  {
    path: "/admin/news/edit/:id",
    element: <PrivateRoute element={<EditNewsPage />} module="news" />,
    title: "Edit News",
  },
  {
    path: "/admin/gallery",
    element: <PrivateRoute element={<AdminGallery />} module="gallery" />,
    title: "Gallery",
  },
  {
    path: "/admin/yuvagaaz",
    element: <PrivateRoute element={<AdminYuvagaazPage />} module="yuvagaaz" />,
    title: "Yuvagaaz",
  },
  {
    path: "/admin/about",
    element: <PrivateRoute element={<AboutAdminPage />} module="about" />,
    title: "About Us",
  },
  {
    path: "/admin/dexco",
    element: <PrivateRoute element={<DexcoAdminPage />} module="about" />,
    title: "DEXCO",
  },
  {
    path: "/admin/deanery-members",
    element: <PrivateRoute element={<DeaneryMembersAdminPage />} module="deanery" />,
    title: "Deanery Members",
  },
  {
    path: "/admin/redon",
    element: <PrivateRoute element={<Redon />} module="redon" />,
    title: "REDON",
  },
  {
    path: "/admin/youcat",
    element: <PrivateRoute element={<YoucatAdminPage />} module="youcat" />,
    title: "YouCat",
  },
  {
    path: "/admin/dyc",
    element: <PrivateRoute element={<DycAdminPage />} module="dyc" />,
    title: "DYC Admin",
  },
  {
    path: "/yuvadabazo",
    element: <DycYuvaDabazoPage />,
    title: "DYC - Yuva Dabazo",
  },
  {
    path: "/yuvadabazo/pitch-battle",
    element: <PitchBattleRegistrationPage />,
    title: "Pitch Battle Registration",
  },
  {
    path: "/yuva-dabazo-registrations-sec-7x9q",
    element: <DycRegistrationListPage />,
    title: "DYC Registration Tracker",
  },
  {
    path: "/yuvagaaz",
    element: <YuvaGaaz />,
    title: "Yuvagaaz",
  },
  {
    path: "/eventsCalendar",
    element: <EventCalender />,
    title: "Events Calendar",
  },
  {
    path: "/news",
    element: <NewsList />,
    title: "News",
  },
  {
    path: "/proYoucatTraining",
    element: <ProAndYoucatTraining />,
    title: "Pro and Youcat Training",
  },
  {
    path: "/proYoucatTraining/registrationList",
    element: <RegistrationList />,
    title: "Registration List",
  },
  {
    path: "/surveyResponse/:id",
    element: <SurveyResponse />,
    title: "Conduct Survey",
  },
  {
    path: "/surveys",
    element: <Surveys />,
    title: "Surveys",
  },
  {
    path: "/admin/surveys",
    element: <PrivateRoute element={<AdminSurveys />} module="surveys" />,
    title: "Surveys",
  },
  {
    path: "/admin/surveys/createSurvey",
    element: <PrivateRoute element={<CreateSurvey isEditFlow={false} />} module="surveys" />,
    title: "Create Survey",
  },
  {
    path: "/admin/surveys/createSurvey/:id",
    element: <PrivateRoute element={<SurveyRespodents />} module="surveys" />,
    title: "respodents",
  },
  {
    path: "/admin/surveys/respodentDetails/:id",
    element: <PrivateRoute element={<Details />} module="surveys" />,
    title: "respodents",
  },
  {
    path: "/admin/surveys/editSurvey/:id",
    element: <PrivateRoute element={<CreateSurvey isEditFlow={true} />} module="surveys" />,
    title: "Create Survey",
  },
  {
    path: "/vanamahostava",
    element: <Vanamahostava />,
    title: "Vanamahotsava",
  },
  {
    path: "*",
    element: <NotFound />,
    title: "NotFound",
  },
  {
    path: "/promptAndPaint",
    element: <PromptAndPaint />,
    title: "Prompt and Paint",
  },
];

export default createBrowserRouter(routes);
